/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-09-23 17:44:01
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-09-23 17:55:53
 * @FilePath: /vue_huaqiang/src/router/modules/guest-information-management.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { RouteConfig } from "vue-router";
import Layout from "@/layout/index.vue";

const GuestInformationManagement: RouteConfig[] = [
  {
    path: "/customerInfoManagement",
    component: Layout,
    redirect: "customerInfoManagement",
    name: "customerInfoManagement",
    meta: {
      title: "customerInfoManagement",
      icon: "el-icon-s-goods",
      alwaysShow: true
    },
    children: [
      {
        path: "list",
        component: () =>
          import("@/views/sales-management/customer/list/index.vue"),
        name: "CustomerManagement",
        meta: { title: "CustomerManagement" }
      },
      {
        path: "/shellPackageInfoManagement",
        name: "shellPackageInfoManagement",
        component: () =>
            import("@/views-oms/package-info-management/shell/index.vue"),
        meta: { title: "shellPackageInfoManagement", hidden: true, activeMenu: "/shellPackageInfoManagement" }
      },
      {
        // 客人下单产品库
        path: "/orderProductLibrary",
        name: "orderProductLibrary",
        component: () =>
          import("@/views-oms/asking-for-quotation-management/OrderProduct.vue"),
        meta: { title: "orderProductLibrary" }
      },
      {
        // 客人报价产品库
        path: "/quotationProductLibrary",
        name: "quotationProductLibrary",
        component: () =>
          import("@/views-oms/asking-for-quotation-management/AskProduct.vue"),
        meta: { title: "quotationProductLibrary" }
      },
      {
        // 表格
        path: "/productCategoryManagement",
        name: "productCategoryManagement",
        component: () =>
          import(
            "@/views-oms/product-business-management/product-hierarchy-management/list.vue"
            ),
        meta: { title: "productCategoryManagement" }
      },
      {
        path: "/packageInfoManagement",
        name: "packageInfoManagement",
        component: () =>
          import("@/views-oms/package-info-management/index.vue"),
        meta: { title: "packageInfoManagement" },
      },
      {
        path: "/formUploadTool",
        component: () =>
          import(
            "@/views-oms/asking-for-quotation-management/FormUploadTool.vue"
          ),
        name: "EnquiryFormManagement",
        meta: { title: "formUploadTool" },
      },
      {
        path: "/taskManagement",
        component: () =>
          import(
            "@/views-oms/asking-for-quotation-management/TaskManagement.vue"
          ),
        name: "TaskManagement",
        meta: { title: "taskManagement" },
      },
      {
        path: "/markManagement",
        name: "markManagement",
        component: () =>
            import("@/views-oms/package-info-management/markManagement/index.vue"),
        meta: { title: "markManagement", hidden: true, activeMenu: "/markManagement" },
      },
      // 额外信息管理
      {
        path: "/otherInfoManagement",
        name: "otherInfoManagement",
        component: () =>
            import("@/views-oms/package-info-management/otherInfoManagement/index.vue"),
        meta: { title: "otherInfoManagement", hidden: true, activeMenu: "/otherInfoManagement" }
      },
      // 包装资料管理
      {
        path: "/packageInfoManagement",
        name: "packageInfoManagement",
        component: () =>
            import("@/views-oms/package-info-management/index.vue"),
        meta: { title: "packageInfoManagement" },
      },
      // 客人包装管理
      {
        path: "/customerPackageManagement",
        name: "customerPackageManagement",
        component: () =>
            import("@/views-oms/customer-package-management/index.vue"),
        meta: { title: "customerPackageManagement" },
      },
      // 客人品牌包装
      {
        path: "/customerBrandPackageList",
        name: "customerBrandPackageList",
        component: () =>
            import("@/views-oms/customer-package-management/customerBrandPackageList.vue"),
        meta: { title: "customerBrandPackageList", hidden: true, activeMenu: "/customerBrandPackageList" },
      },
      // 装箱资料管理
      {
        path: "/packingMaterialManagement",
        name: "packingMaterialManagement",
        component: () =>
            import("@/views-oms/package-info-management/material/index.vue"),
        meta: { title: "packingMaterialManagement", hidden: true, activeMenu: "/packageInfoManagement" }
      },
         // 品牌管理
      {
        path: "/brandManagement",
        name: "brandManagement",
        component: () =>
            import("@/views-oms/package-info-management/brandManagement/index.vue"),
        meta: { title: "brandManagement", hidden: true, activeMenu: "/brandManagement" }
      },
    ]
  }
];

export default GuestInformationManagement;
